var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75v16.5h16.5V3.75zm18 16.5a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V3.75a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0M7.5 16.5v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.5v-3.375a1.875 1.875 0 1 0-3.75 0 .75.75 0 0 1-1.5 0 3.375 3.375 0 0 1 6.75 0V16.5a.75.75 0 0 1-1.5 0M8.25 9a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })));
};
export default SvgLinkedin;